<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar v-model="formData" :shopOptions="shopOptions" :propList="propList" :exportData="exportData" @search="handleSearch"></search-bar>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="table"
          border
          stripe
          :data="tableData"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
          @sort-change="handleSortChange"
        >
           <el-table-column
              :label="item.label"
              :prop="item.prop"
              :fixed="item.fixed"
              show-overflow-tooltip
              :sortable="item.sortable ? 'custom' : false"
              v-for="item in propList"
              min-width="100px"
              :key="item.prop"
              align="center"
            >
            <template slot-scope="scope">
              <template v-if="item.label === '图片'">
                <el-link type="primary" :underline="false" @click="showDialog(scope.row, 0)" v-if="scope.row.imgUrlList.length">查看</el-link>
                <el-link :underline="false" disabled v-else>查看</el-link>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
           </el-table-column>
          <!-- <el-table-column fixed label="图片" prop="" show-overflow-tooltip align="center" width="100px">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showDialog(scope.row, 0)" v-if="scope.row.imgUrlList.length">查看</el-link>
              <el-link :underline="false" disabled v-else>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column fixed label="产品编码" prop="productCode" show-overflow-tooltip width="180px" sortable="custom"></el-table-column>
          <el-table-column fixed label="产品名称" prop="productName" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="上市天数" prop="dayNum" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="上市时间" prop="upTime" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="所属店铺" prop="storeName" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="推新次数" prop="newPushTimes" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="累计销量" prop="total" show-overflow-tooltip width="120px" sortable="custom">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="actualSaleVisible = true; activeRow = scope.row;">{{scope.row.total}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="平均成交价" prop="avgTransactionPrice" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="A类价" prop="priceA" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="京东自营厂" prop="jdzyc" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="京东一店" prop="jd1" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="京东二店" prop="jd2" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="精品店" prop="jpd" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="猫宁自营厂" prop="mnzyc" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="拼多多" prop="pdd" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="苏宁店" prop="snd" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="苏宁自营厂" prop="snzyc" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="天猫一店" prop="tm1" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="天猫二店" prop="tm2" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="唯品会" prop="wph" show-overflow-tooltip width="120px" sortable="custom"></el-table-column>
          <el-table-column label="专卖店" prop="zmd" show-overflow-tooltip width="120px" sortable="custom"></el-table-column> -->
        </el-table>
        <div style="overflow: hidden;">
          <div style="float: left; margin-top: 15px; color: #555;">
            <span>{{dataUpdateObj.updateContent}}：</span>
            <span>{{dataUpdateObj.latestUpdateTime}}</span>
          </div>
          <el-pagination
            style="float: right; margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <!-- 图片&视频 -->
    <pic-video :data="rowData" :detailType="viewType" ref="picVideo"></pic-video>
    <actual-sale :data="activeRow" v-model="actualSaleVisible" v-if="actualSaleVisible"></actual-sale>
  </div>
</template>

<script>
  import mixin from '@/views/preSalePlan/utils/mixin.js'
  import searchBar from './search'

  import picVideoMixin from './pic&video.mixin'
  import actualSale from './actualSale'
  export default {
    mixins: [mixin, picVideoMixin],
    components: {
      searchBar,
      actualSale
    },
    props: ['form', 'dataUpdateObj'],
    data() {
      return {
        tableHeight: 0,
        loading: false,
        formData: {
          storeId: ''
        },
        tableData: [],
        propList: [],
        exportData: {},
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        },
        shopOptions: [],
        descOrAsc: '',
        fieldName: '',
        actualSaleVisible: false,
        activeRow: null
      }
    },
    mounted() {
      this.tableHeight = this.$refs['wrapper'].offsetHeight - 105;
      this.init();
      this.get_shopOptions();
    },
    methods: {
      handleSearch(data,type) {
        if(type == 1) {
          this.descOrAsc = '';
          this.fieldName = '';
          this.$refs.table.clearSort()
        }
        this.paginationOpt.pageNum = 1;
        this.formData = data;
        this.init();
      },
      init(type) {
        this.loading = true;
        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.formData,
            descOrAsc: this.descOrAsc,
            fieldName: this.fieldName,
            exportTag: false
          }
        };
        this.exportData = formData
        this.$q.preSalePlan.getNewProductA({data: formData})
        .then(res=>{
          this.tableData = res.data ? res.data.records : [];
          if(!type) {
            this.propList = []
            res.data.titleList.forEach(v=>{
              this.propList.push({
                label: v.titleName,
                prop: v.propertyName,
                width: v.width,
                sortable: v.sortable == '1' ? "custom" : false,
                span: false,
                fixed: v.fixed ? v.fixed : false,
                align: v.align
              })
          })
          }
          console.log(this.propList);
          this.paginationOpt['total'] = res.data.total;
        })
        .finally(_=>{
          this.loading = false;
        })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      },
      // 所属店铺下拉数据
      get_shopOptions() {
        this.$q.preSalePlan.storeSelect()
        .then(res=>{
          this.shopOptions = res.data;
        })
      },
      handleSortChange({column, prop, order}) {
        this.paginationOpt.pageNum = 1;
        console.log({column, prop, order});
        if(order === null) {
          this.descOrAsc = '';
          this.fieldName = '';
        }
        if(order === 'ascending') {
          this.descOrAsc = '';
          this.fieldName = prop;
        }
        if(order === 'descending'){
          this.descOrAsc = 'desc';
          this.fieldName = prop;
        }
        this.init(true);
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .container
    width auto 
    height calc(100% - 110px)
    box-sizing border-box
    border-radius 5px
  >>> .el-header
    background #ffffff
    padding 0 8px
    position relative
    border-radius 5px
  >>> .el-main
    padding 5px 8px
    background #ffffff
    border-radius 5px
</style>